import React from 'react'
import styles from './DataRowStatusLine.less'
import { FAIcon } from '../FAIcon'
import { ImgURL } from '../ImgURL'

export class DataRowStatusLine extends React.Component {
  render () {
    const { data } = this.props

    let pictureDiv = null

    if (data.showPicture) {
      if (data.picture) {
        pictureDiv = <div className={styles.assignmentImg}><ImgURL src={data.picture} /></div>
      } else {
        pictureDiv = <div className={styles.assignmentImgEmpty} ><FAIcon name={data.emptyPictureIcon || 'user'} /></div>
      }
    }

    return (<div className={styles.cardFlexRow}>
      <div className={styles.card2Col}>
        <div className={styles.cardInfoColumnTitle}>{data.title}</div>
        <div className={styles.assignmentInfoWrapper}>
          {pictureDiv}
          <div className={styles.assignmentInfo}>
            <div className={styles.assignmentNameText}>{data.assignmentName}</div>
            <div className={styles.assignmentPhoneText}>{data.assignmentPhone}</div>
          </div>
        </div>
      </div>
      <div className={styles.card2ColStatusFlex}>
        <div>
          <div className={styles.statusTitles}>{data.status}</div>
          <div className={styles[`underlineDiv${data.status || ''}`]}></div>
        </div>
      </div>
    </div>
    )
  }
}

export default DataRowStatusLine
